import { render, staticRenderFns } from "./changeButton.vue?vue&type=template&id=def3347e&"
import script from "./changeButton.vue?vue&type=script&lang=js&"
export * from "./changeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports